/**
 * @generated SignedSource<<17200bbcf4f3745fffb6460dfca3c76b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReorderRulesInputObject = {
  orderedIds: ReadonlyArray<string>;
};
export type rulesPage_ReorderRulesMutation$variables = {
  input: ReorderRulesInputObject;
};
export type rulesPage_ReorderRulesMutation$data = {
  readonly reorderRules: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rules: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
};
export type rulesPage_ReorderRulesMutation = {
  response: rulesPage_ReorderRulesMutation$data;
  variables: rulesPage_ReorderRulesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rules",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_ReorderRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderRulesMutationPayload",
        "kind": "LinkedField",
        "name": "reorderRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_ReorderRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderRulesMutationPayload",
        "kind": "LinkedField",
        "name": "reorderRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8212eb8298e47217d84cedc699dafcd",
    "id": null,
    "metadata": {},
    "name": "rulesPage_ReorderRulesMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_ReorderRulesMutation(\n  $input: ReorderRulesInputObject!\n) {\n  reorderRules(input: $input) {\n    rules {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2728ffbe18a1f920cd359d8bd3b0bbc9";

export default node;
